var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["opening-hours", { isSimple: _vm.isSimple }] },
    [
      _vm._t("default", null, {
        isOpen: _vm.isOpen,
        isSimple: _vm.isSimple,
        isBranch: _vm.isBranch,
        onOpeningHoursClick: _vm.onOpeningHoursClick,
        showOpeningHours: _vm.showOpeningHours,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }